import { Button, Modal, Tab, Tabs } from 'react-bootstrap';
import { LerTipoMovimentacoes } from '@/modules/business/movimentacoes_tipos/movimentacaotipo.service';
import { useEffect, useState } from 'react';
import { ReadMovimentacaoTipoDto } from '@/api.types';

interface ModalFiltrosRelatorioMovimentacoesProps {
  show: boolean;
  handleHide: () => void;
  handleBuscar: (params: number[]) => void;
}

export default function ModalTiposDeMovimentos({
  show,
  handleHide,
  handleBuscar,
}: ModalFiltrosRelatorioMovimentacoesProps) {
  const [tiposIniciais, setTiposIniciais] = useState<ReadMovimentacaoTipoDto[]>([]);
  const [tiposNucleos, setTiposNucleos] = useState<ReadMovimentacaoTipoDto[]>([]);

  const [
    tiposSelecionadosDefensoriaIniciais,
    setTipoSelecionadosDefensoriaIniciais,
  ] = useState<number[]>([]);
  const [tiposSelecionadosDefensoria, setTipoSelecionadosDefensoria] = useState<
    number[]
  >([]);
  const [tiposSelecionadosNucleoIniciais, setTipoSelecionadosNucleosIniciais] =
    useState<number[]>([]);
  const [tiposSelecionadosNucleos, setTipoSelecionadosNucleos] = useState<
    number[]
  >([]);

  function onSubmit() {
    const tiposSelecionados = tiposSelecionadosDefensoriaIniciais
      .concat(tiposSelecionadosDefensoria)
      .concat(tiposSelecionadosNucleoIniciais)
      .concat(tiposSelecionadosNucleos);

    handleBuscar(tiposSelecionados);
    handleHide();
  }

  useEffect(() => {
    Promise.all([
      LerTipoMovimentacoes(0, 1000, false),
      LerTipoMovimentacoes(0, 1000, true),
    ]).then(([tiposIniciais, tiposNucleos]) => {
      setTiposIniciais(tiposIniciais.objects);
      setTiposNucleos(tiposNucleos.objects);
    });
  }, []);

  return (
    <Modal show={show} onHide={handleHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Tipos de Movimentações</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
        <Tabs
          defaultActiveKey="defensorias-iniciais"
          id="movimentacoes-tabs"
          className="mb-3"
        >
          <Tab eventKey="defensorias-iniciais" title="Defensorias (iniciais)">
            <div className="row">
              <div className="col-auto">
                <button
                  onClick={() =>
                    setTipoSelecionadosDefensoriaIniciais(
                      tiposIniciais
                        .filter((item) => item.inicial)
                        .map((item) => item.id),
                    )
                  }
                  className="btn btn-sm btn-success"
                  title="Marcar Tudo"
                >
                  Marcar Tudo
                </button>
              </div>
              <div className="col-auto">
                <button
                  onClick={() => setTipoSelecionadosDefensoriaIniciais([])}
                  className="btn btn-sm btn-outline-success"
                  title="Desmarcar Tudo"
                >
                  Desmarcar Tudo
                </button>
              </div>
              <hr className="mt-3" />

              {tiposIniciais != null &&
                tiposIniciais
                  .filter((item) => item.inicial)
                  .map((item, index) => (
                    <div key={index} className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`tipo-${item.id}`}
                          value={item.id}
                          checked={tiposSelecionadosDefensoriaIniciais.includes(
                            item.id,
                          )}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            const value = Number(e.target.value);
                            setTipoSelecionadosDefensoriaIniciais((prev) =>
                              e.target.checked
                                ? [...prev, value]
                                : prev.filter((id) => id !== value),
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`tipo-${item.id}`}
                        >
                          {item.descricao}
                        </label>
                      </div>
                    </div>
                  ))}
            </div>
          </Tab>

          <Tab
            eventKey="defensorias-nao-iniciais"
            title="Defensorias (não iniciais)"
          >
            <div className="row">
              <div className="col-auto">
                <button
                  onClick={() =>
                    setTipoSelecionadosDefensoria(
                      tiposIniciais
                        .filter((item) => !item.inicial)
                        .map((item) => item.id),
                    )
                  }
                  className="btn btn-sm btn-success"
                  title="Marcar Tudo"
                >
                  Marcar Tudo
                </button>
              </div>
              <div className="col-auto">
                <button
                  onClick={() => setTipoSelecionadosDefensoria([])}
                  className="btn btn-sm btn-outline-success"
                  title="Desmarcar Tudo"
                >
                  Desmarcar Tudo
                </button>
              </div>
              <hr className="mt-3" />

              {tiposIniciais != null &&
                tiposIniciais
                  .filter((item) => !item.inicial)
                  .map((item, index) => (
                    <div key={index} className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`tipo-${item.id}`}
                          value={item.id}
                          checked={tiposSelecionadosDefensoria.includes(
                            item.id,
                          )}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            const value = Number(e.target.value);
                            setTipoSelecionadosDefensoria((prev) =>
                              e.target.checked
                                ? [...prev, value]
                                : prev.filter((id) => id !== value),
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`tipo-${item.id}`}
                        >
                          {item.descricao}
                        </label>
                      </div>
                    </div>
                  ))}
            </div>
          </Tab>

          <Tab eventKey="nucleo-iniciais" title="Núcleos (iniciais)">
            <div className="row">
              <div className="col-auto">
                <button
                  onClick={() =>
                    setTipoSelecionadosNucleosIniciais(
                      tiposNucleos
                        .filter((item) => item.inicial)
                        .map((item) => item.id),
                    )
                  }
                  className="btn btn-sm btn-success"
                  title="Marcar Tudo"
                >
                  Marcar Tudo
                </button>
              </div>
              <div className="col-auto">
                <button
                  onClick={() => setTipoSelecionadosNucleosIniciais([])}
                  className="btn btn-sm btn-outline-success"
                  title="Desmarcar Tudo"
                >
                  Desmarcar Tudo
                </button>
              </div>
              <hr className="mt-3" />

              {tiposNucleos != null &&
                tiposNucleos
                  .filter((item) => item.inicial)
                  .map((item, index) => (
                    <div key={index} className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`tipo-${item.id}`}
                          value={item.id}
                          checked={tiposSelecionadosNucleoIniciais.includes(
                            item.id,
                          )}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            const value = Number(e.target.value);
                            setTipoSelecionadosNucleosIniciais((prev) =>
                              e.target.checked
                                ? [...prev, value]
                                : prev.filter((id) => id !== value),
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`tipo-${item.id}`}
                        >
                          {item.descricao}
                        </label>
                      </div>
                    </div>
                  ))}
            </div>
          </Tab>

          <Tab eventKey="nucleo-nao-iniciais" title="Núcleos (não iniciais)">
            <div className="row">
              <div className="col-auto">
                <button
                  onClick={() =>
                    setTipoSelecionadosNucleos(
                      tiposNucleos
                        .filter((item) => !item.inicial)
                        .map((item) => item.id),
                    )
                  }
                  className="btn btn-sm btn-success"
                  title="Marcar Tudo"
                >
                  Marcar Tudo
                </button>
              </div>
              <div className="col-auto">
                <button
                  onClick={() => setTipoSelecionadosNucleos([])}
                  className="btn btn-sm btn-outline-success"
                  title="Desmarcar Tudo"
                >
                  Desmarcar Tudo
                </button>
              </div>
              <hr className="mt-3" />

              {tiposNucleos != null &&
                tiposNucleos
                  .filter((item) => !item.inicial)
                  .map((item, index) => (
                    <div key={index} className="col-md-4">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`tipo-${item.id}`}
                          value={item.id}
                          checked={tiposSelecionadosNucleos.includes(item.id)}
                          onChange={(
                            e: React.ChangeEvent<HTMLInputElement>,
                          ) => {
                            const value = Number(e.target.value);
                            setTipoSelecionadosNucleos((prev) =>
                              e.target.checked
                                ? [...prev, value]
                                : prev.filter((id) => id !== value),
                            );
                          }}
                        />
                        <label
                          className="form-check-label"
                          htmlFor={`tipo-${item.id}`}
                        >
                          {item.descricao}
                        </label>
                      </div>
                    </div>
                  ))}
            </div>
          </Tab>
        </Tabs>
      </Modal.Body>
      <Modal.Footer>
        <Button type="submit" variant="success" onClick={() => onSubmit()}>
          Aplicar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
